<template>
  <WhitePage :loading="loading">
    <title-bar>スポット</title-bar>
    <!-- <action-nav /> -->
    <p>
      現在地にスポットを作成、または既に作成したスポットを修正します。
      スポットは異世界につき１つずつ作成可能です。
    </p>
    <b-alert variant="warning" show>
      注：今のところ作成したスポットは削除できません！
    </b-alert>
    <b-table-simple hover small>
      <b-thead>
        <b-tr>
          <b-th>スポット名</b-th>
          <b-th>世界</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr variant="light" v-for="v in list" :key="v.key">
          <b-td>
            <router-link :to="{ path:`spot/${v.key}` }">
              {{v.name}}
              <font-awesome-icon icon="pen" class="icon fa-sx" />
            </router-link>
            <b-badge v-if="v.entry">New</b-badge>
          </b-td>
          <b-td>
            {{v.world}}
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <b-alert variant="warning" :show="warnSpot === 1">
      この地点はスポットです！スポット上にスポットは作成できません！
    </b-alert>
    <b-button @click="$router.push('spot/new')"
      :disabled="enableAddSpot == 0 || warnSpot === 1"
    >
      <font-awesome-icon icon="plus-square" class="icon fa-1x" />
      {{location}}にスポット設置
    </b-button>
    あと{{enableAddSpot}}個設置可能
    <pagenate>
      <template #previous>
        <b-icon icon="chevron-left" />
        <router-link to="/makeevent">イベント作成</router-link>
      </template>
      <template #next>
        <router-link to="/myworld">異世界</router-link>
        <b-icon icon="chevron-right" />
      </template>
    </pagenate>
  </WhitePage>
</template>
'
<script>
import phina from 'phina.js'
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
// import RemarkEditor from '@/components/RemarkEditor'
// import IconDropdown from '@/components/IconDropdown'
// import ActionNav from '@/components/ActionNav'
// import ResponseMessage from '@/components/ResponseMessage'
// import CodeEditor from '@/components/CodeEditor'
// import _ from 'lodash'
import Pagenate from '@/components/Pagenate'
export default {
  components: {
    WhitePage,
    TitleBar,
    // RemarkEditor,
    // IconDropdown,
    // ActionNav,
    // ResponseMessage,
    // CodeEditor
    Pagenate
  },
  data () {
    return {
      list: {},
      enableAddSpot: 0,
      location: '',
      warnSpot: false,
      loading: false
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      this.list = response.list
      this.enableAddSpot = response.enableAddSpot
      this.location = response.location
      this.warnSpot = response.warnSpot
    }
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getSpotList')
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    this.checkLogin()
  },
  mounted () {
    phina.global.app.currentScene.exit('MainScene')
  }
}
</script>

<style lang="scss" scoped>
</style>
